import { render, staticRenderFns } from "./ComboRoles.vue?vue&type=template&id=57814134&scoped=true"
import script from "./ComboRoles.vue?vue&type=script&lang=ts"
export * from "./ComboRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57814134",
  null
  
)

export default component.exports